import { withRouter, Link } from "react-router-dom";

const PokemonDetails = (props) => {
    return(
        <div className="pokemon-details">
            <div>
                <img
                    src={props.pokemon.img}
                    alt={props.pokemon.name}
                />
            </div>
            <div>
                <div>
                    <div>{props.pokemon.ntnlnum.match(/\d+/g)[0]*1}</div>
                    <div>{props.pokemon.name}</div>
                    <div>{props.pokemon.description}</div>
                    {
                        props.pokemon.types.map((type)=>
                            <Link to={`/pokedex/`+type} key={type}>
                                <div className={type + " typebox"}>{type}</div>
                            </Link>
                        )
                    }
                </div>
                <div>
                    <button onClick={props.history.goBack} >
                        Back
                    </button>
                </div>
            </div>
        </div>
    )
}

export default withRouter(PokemonDetails)